import { TemplateItem } from "types/";
import { Avatar } from "../../../types";
import { generateAvatarGraphics } from "../graphicGenerators/Avatar";
import {
  defaultAnchor,
  generateRotationAttribute,
} from "../../mapTemplateStateToServerTemplate";
import { getNumberRoundedToPrecision } from "../..";

export const generateAvatarItem = (
  presenter: Avatar,
  aspectRatio: number
): TemplateItem => {
  const avatarStrokeWidth = presenter.stroke?.width ?? 0;
  const avatarStrokeHeight = avatarStrokeWidth * aspectRatio;
  return {
    name: "avatar",
    graphics: generateAvatarGraphics(presenter.avatarShape),
    attributes: [
      {
        type: "Position",
        position: {
          type: "Align",
          vertical: "center",
          horizontal: "center",
          reference: "avatar_background",
        },
      },
      {
        type: "Height",
        rate: getNumberRoundedToPrecision(
          presenter.size.height - avatarStrokeHeight * 2
        ),
      },
      // The avatar is centered on (shares the center of) avatar_background, so
      // the same rotation keeps the face and its background aligned.
      ...(presenter.rotation
        ? [generateRotationAttribute(presenter.rotation)]
        : []),
    ],
    ...defaultAnchor,
  };
};
